import {Observable} from 'rxjs'
import {filter} from 'rxjs/operators'

export const filterNull = <T>() =>
    (o: Observable<T>): Observable<T> =>
        o.pipe(filter(x => !!x))
